import { action } from 'satcheljs';

/**
 * Action called to expand the path till the given node.
 */
export default action('expandPathTillNode', (rootId: string, nodeId: string) => ({
    rootId,
    nodeId,
}));
